module.exports = __webpack_public_path__ + "static/img/12.bb0549a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/12.png
// module id = olv2
// module chunks = 2